import React, { useState, useEffect } from 'react';
import axios from 'axios';
import bell from '../../../pages/admin/admin_assets/img/bell.svg';        
import stop from '../../../pages/admin/admin_assets/img/stop.svg';   
import { useNavigate, useLocation } from 'react-router-dom';
import config from '../../../config/config.js';
import Dropdown from 'react-bootstrap/Dropdown';
import Modal from 'react-bootstrap/Modal';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { Avatar, Badge } from 'antd';

import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Header = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const [show, setShow] = useState(false);
    const [userData, setUserData] = useState({}); // Holds user data
    const [language, setLanguage] = useState('English'); // Default language
    const [unreadNotifications, setUnreadNotifications] = useState([]);
    const [unreadCount, setUnreadCount] = useState(0);

    const [name, setName] = useState('');
      const [role, setRole] = useState('');
      const [email, setEmail] = useState('');
      const [profilePicture, setProfilePicture] = useState(null);

    useEffect(() => {
        const fetchUserData = async () => {
          try {
            const response = await axios.get(`${config.API_BASE_URL}/get-user-data.php`, {
              withCredentials: true,
            });
            
    
            if (response.data.success) {
              setName(response.data.data || '');
              setRole(response.data.role || '');
              setEmail(response.data.email || '');
              setProfilePicture(response.data.profile_picture || '');
            } else {
                navigate('/');
              console.error('Error fetching user data:', response.data.message);
            }
          } catch (error) {
            console.error('Error fetching user data:', error.response?.data?.message || error.message);
          }
        };
    
        fetchUserData();
      }, []);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const displayName = name || 'BYB';
    const profileInitial = name ? name.charAt(0).toUpperCase() : 'B';

    const Testcheck = ()=>{
        console.log('test check');
        
    }
    return (
        <nav className="navbar bg-white topbar mb-4 static-top">
            <button id="sidebarToggleTop" className="btn btn-link d-md-none rounded-circle mr-3">
                <i className="fa fa-bars"></i>
            </button>

            <div className="top_header">
                <div className="theme_switch" onClick={handleShow}>
                    <img src={bell} alt="Notifications" />
                    <Badge count={unreadCount}>
                        <Avatar shape="circle" size="large" />
                    </Badge>
                </div>

                <div className="profile">
                    <Dropdown>
                        <Dropdown.Toggle variant="success" id="dropdown-basic" className="border-0">
                            <div className="pro-img profile_photo">
                                {profilePicture ? (
                                    <img src={`${config.API_BASE_URL}/uploads/${profilePicture}`} alt="Profile" />
                                ) : (
                                    <span>{profileInitial}</span>
                                )}
                            </div>

                            <div className="profile_detail">
                                <p>{displayName}</p>
                                <span>{role || 'Admin'}</span>
                            </div>

                            <div className="down_arrow">
                                {/* Optional arrow icon */}
                            </div>
                        </Dropdown.Toggle>
                    </Dropdown>
                </div>

                <Modal show={show} onHide={handleClose} backdrop="static" className="notification_modal">
                    <Modal.Header closeButton>
                        <div className="notiy_title">
                            <h5>Notifications</h5>
                            <p>Stay updated with your latest notifications</p>
                        </div>
                    </Modal.Header>

                    <Tabs defaultActiveKey="All" id="uncontrolled-tab-example" className="mb-3 notify_check">
                        <Tab eventKey="All" title="All">
                            {unreadNotifications.length === 0 ? (
                                <p>No notifications available.</p>
                            ) : (
                                unreadNotifications.map((notification) => (
                                    <div key={notification.id} className="notify_content">
                                        <img src={stop} alt="Notification" />
                                        <div className="stay_notify">
                                            <p className="mb-0">{notification.notification}</p>
                                            <span>{new Date(notification.datetime).toLocaleString()}</span>
                                        </div>
                                    </div>
                                ))
                            )}
                        </Tab>
                        <Tab eventKey="Unread" title={`Unread (${unreadCount})`}>
                            {unreadNotifications.length === 0 ? (
                                <p>No unread notifications.</p>
                            ) : (
                                unreadNotifications.map((notification) => (
                                    <div key={notification.id} className="notify_content">
                                        <img src={stop} alt="Notification" />
                                        <div className="stay_notify">
                                            <p className="mb-0">{notification.notification}</p>
                                            <span>{new Date(notification.datetime).toLocaleString()}</span>
                                        </div>
                                    </div>
                                ))
                            )}
                        </Tab>
                        <Tab eventKey="MarkAllReads"  title="Mark all as reads">
                            <div className="last_marked" >
                                <span >Mark all as reads</span>
                            </div>
                            
                        </Tab>
                        
                    </Tabs>
                    {/* <div className="last_marked" onClick={Testcheck}>
                                <span>Mark all as read</span>
                            </div> */}
                </Modal>
            </div>

            <ToastContainer />
        </nav>
    );
};

export default Header;
